import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { API_BASE_URL } from "../../config/connect";

const ComfortFeatures = ({ onComfortFeaturesSelected }) => {
  const [selectedComfortFeatures, setSelectedComfortFeatures] = useState(null);
  const [variations, setVariations] = useState([]);
  const { prodcode } = useParams();

  const getAllProductVariations = async () => {
    try {
      const response = await fetch(
        `https://ghmarkets.net/test/ghmarketconnect/?ghw=productservices&svg=fashionvariations&prcode=${prodcode}`
      );
      const json = await response.json();
      const firstResult = json["results"][0];
      if (firstResult && firstResult.comfortfeatures) {
        const comfortFeaturesObject = firstResult.comfortfeatures;
        if (comfortFeaturesObject.trim() !== "") {
          setVariations(comfortFeaturesObject.split(","));
        }
      }
    } catch (error) {
      // Handle error here
    }
  };

  useEffect(() => {
    getAllProductVariations();
  }, [prodcode]);

  const handleComfortFeaturesClick = (comfortfeatures) => {
    setSelectedComfortFeatures(comfortfeatures);
    onComfortFeaturesSelected(comfortfeatures);
  };

  return variations.length > 0 ? (
    <div
      className="sizes-container"
      style={{ display: "flex", flexDirection: "row" }}
    >
      <span
        style={{
          fontSize: "",
          fontWeight: "bold",
          color: "black",
          marginTop: "12px",
        }}
      >
        Comfort Features:
      </span>
      <div className="sizes">
        {variations.map((variation, i) => (
          <div
            key={i}
            className={`size ${selectedComfortFeatures === variation ? "selected" : ""}`}
            onClick={() => handleComfortFeaturesClick(variation)}
          >
            {variation}
          </div>
        ))}
      </div>
    </div>
  ) : (
    ""
  );
};

export default ComfortFeatures;
